import * as React from "react";
import { Modal, Steps } from "antd";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import { DownloadOverview } from "./DownloadOverview";
import { fileDownloadStore } from "./FileDownloadStore";
import { DownloadOptions } from "./DownloadOptions";

interface FileDownloadProps extends WithTranslation {}

interface FileDownloadState {
  current: number;
}

export const FileDownload = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<FileDownloadProps, FileDownloadState> {
      constructor(props: FileDownloadProps) {
        super(props);

        this.state = {
          current: 0,
        };
      }

      next = () => {
        this.setState({ current: this.state.current + 1 });
      };

      prev = () => {
        this.setState({ current: this.state.current - 1 });
      };

      submit = async () => {
        try {
          fileDownloadStore.download();
          this.reset();
        } catch (error) {
          throw error;
        }
      };

      reset = () => {
        fileDownloadStore.hideModal();
        this.setState({ current: 0 });
      };

      get steps() {
        const { postOptions, postFiles, ledOptions, initialData, setOptions, downloadMode } = fileDownloadStore;

        return [
          {
            title: "File selection",
            description: "These are the selected files",
            content: <DownloadOverview onNext={this.next} onDone={this.submit} />,
          },
          {
            title: "Additional Options",
            description: "Pick your flavor",
            content: (
              <DownloadOptions
                downloadMode={downloadMode}
                downloadOptions={postOptions}
                options={ledOptions}
                onChange={setOptions}
                filesAmount={Object.prototype.hasOwnProperty.call(initialData, "files") ? postFiles.length : 0}
                onBack={this.prev}
                onDone={this.submit}
              />
            ),
          },
        ];
      }

      render() {
        const { current } = this.state;
        const { t } = this.props;
        const { isVisible, downloadMode } = fileDownloadStore;
        const title = downloadMode === "RWM" ? "Download files with watermark" : "Download files";

        return (
          <Modal
            style={{ maxWidth: `calc(100vw - 40px)` }}
            width={"100%"}
            className="full-height-modal"
            footer={null}
            title={t(title)}
            open={isVisible}
            destroyOnHidden={true}
            onCancel={this.reset}
            zIndex={1011}
          >
            <div className="upload-modal-body">
              <div className="mb-2">
                <Steps
                  current={current}
                  style={{ maxWidth: 985 }}
                  items={this.steps.map((item) => ({
                    key: item.title,
                    title: t(item.title),
                    subTitle: t(item.description),
                  }))}
                />
              </div>
              <div style={{ flexGrow: 1 }}>{this.steps[current].content}</div>
            </div>
          </Modal>
        );
      }
    }
  )
);
